/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Method_RequiredInputs */

const vi_tea_purchase_payment_method_required = /** @type {(inputs: Tea_Purchase_Payment_Method_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn hình thức thanh toán`)
};

/**

* @param {Tea_Purchase_Payment_Method_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_method_required = /** @type {((inputs?: Tea_Purchase_Payment_Method_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Method_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_method_required(inputs)
});